import React from 'react';
import RoutedLayout from 'components/Layout/RoutedLayout';
import routes from './routes';

const DataSourceSettings = () => <RoutedLayout sidebar routes={routes} path="/data-sources/:dataSourceId/settings/:page?" />;

export default DataSourceSettings;
